import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Toggle from "../../components/common/toggle";
import { HiDotsVertical } from "react-icons/hi";
import { IoBagAdd, IoEye } from "react-icons/io5";
import { MdOutlineModeEdit, MdDeleteOutline } from "react-icons/md";
import Pagination from "../../components/common/pagination";
import { useViewMedia } from "../../hooks/media/media.show";
import { useRemvoeMedia } from "../../hooks/media/media.delete";
import toast from "react-hot-toast";
import Swal from "sweetalert2";

const Multimedias = () => {
  const navigate = useNavigate();
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [upmedia, setUpmedia] = useState([]);
  const [initialProducts, setInitialProducts] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationInfo, setPaginationInfo] = useState(null);

  const [menuPosition, setMenuPosition] = useState({});

  const { data: mediaData, isLoading } = useViewMedia({ page: currentPage, limit: 10 });
  const { mutate: deleteMedia } = useRemvoeMedia();

  useEffect(() => {
    const list = mediaData?.data?.data || [];
    const pagination = mediaData?.data?.pagination || mediaData?.pagination;

    console.log("Media list:", list);
    console.log("Pagination info:", pagination);

    if (Array.isArray(list)) {
      const formatted = list.map((item) => ({
        id: item._id,
        title: item.title,
        fileType: item.type?.toUpperCase() || "-",
        industry:
          typeof item.industry === "string"
            ? item.industry
            : item.industry?.title || "-",
        tag: typeof item.tags === "string" ? item.tags : item.tags?.name || "-",
        views: item.analytics?.views || 0,
        share: item.analytics?.share || 0,
        downloads: item.analytics?.downloads || 0,
        status: item.status,
      }));

      setUpmedia(formatted);
      setInitialProducts(formatted);
    }

    if (pagination) {
      setPaginationInfo(pagination);
    }
  }, [mediaData]);

  useEffect(() => {
    const closeMenu = () => setActiveDropdown(null);
    window.addEventListener("scroll", closeMenu, true);
    window.addEventListener("resize", closeMenu);
    window.addEventListener("click", closeMenu);
    return () => {
      window.removeEventListener("scroll", closeMenu, true);
      window.removeEventListener("resize", closeMenu);
      window.removeEventListener("click", closeMenu);
    };
  }, []);

  const handleActionClick = (e, id) => {
    e.stopPropagation();
    if (activeDropdown === id) {
      setActiveDropdown(null);
    } else {
      const rect = e.currentTarget.getBoundingClientRect();
      setMenuPosition({
        position: "fixed",
        top: `${rect.bottom + 5}px`,
        left: "auto",
        right: `${window.innerWidth - rect.right}px`,
        transform: "none",
        zIndex: 10000,
        width: "max-content",
      });
      setActiveDropdown(id);
    }
  };

  // Handle search input and filter distributors
  const handleSearch = (e) => {
    const value = e.target ? e.target.value : e;
    setSearchTerm(value);
    if (value.trim() === "") {
      setUpmedia(initialProducts);
    } else {
      setUpmedia(
        initialProducts.filter(
          (product) =>
            product.name.toLowerCase().includes(value.toLowerCase()) ||
            product.slug.toLowerCase().includes(value.toLowerCase()) ||
            product.status.toLowerCase().includes(value.toLowerCase()),
        ),
      );
    }
  };
 const handleDelete = (id) => {
  Swal.fire({
    title: "Delete Media?",
    text: "Are you sure you want to delete this media?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: "Yes, delete it",
    cancelButtonText: "Cancel",
  }).then((result) => {
    if (result.isConfirmed) {
      deleteMedia(id, {
        onSuccess: () => {
        toast.success("Media deleted successfully");

          setUpmedia((prev) =>
            prev.filter((product) => product.id !== id)
          );
        },
        onError: (error) => {
          toast.error(error?.message || "Failed to delete media");
        }
      });
    } 
  });
};

  const handleRowClick = (product) => {
    navigate(`/products/view/${product.id}`, {
      state: { product },
    });
  };

  const handleToggleStatus = (id, newStatus) => {
    setUpmedia((prev) =>
      prev.map((product) =>
        product.id === id ? { ...product, status: newStatus } : product,
      ),
    );
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (isLoading) {
    return (
      <div style={{ padding: 40, textAlign: "center" }}>Loading media...</div>
    );
  }

  return (
    <>
      <button
        className="commonButton"
        style={{ marginLeft: "auto" }}
        onClick={() => (window.location.href = "/mediauploads/AddMultimedia")}
      >
        <IoBagAdd size={20} color="#ffffff" style={{ marginRight: 8 }} /> Add
        Media
      </button>
      <div className="distributor-table-container" style={{
        background: '#fff',
        borderRadius: '12px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
        overflow: 'hidden',
        border: '1px solid #f0f0f0'
      }}>
        <table className="distributor-table" style={{
          width: '100%',
          borderCollapse: 'separate',
          borderSpacing: '0'
        }}>
          <thead>
            <tr className="distributor-table-head-tr" style={{
              background: 'linear-gradient(to bottom, #fafafa, #f5f5f5)',
              borderBottom: '2px solid #e8e8e8'
            }}>
              <th className="distributor-th distributor-text-center" style={{
                padding: '16px 12px',
                textAlign: 'center',
                fontSize: '13px',
                fontWeight: '600',
                color: '#666',
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                borderBottom: '2px solid #e0e0e0'
              }}>Title</th>
              <th className="distributor-th distributor-text-center" style={{
                padding: '16px 12px',
                textAlign: 'center',
                fontSize: '13px',
                fontWeight: '600',
                color: '#666',
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                borderBottom: '2px solid #e0e0e0'
              }}>
                File Type
              </th>
              <th className="distributor-th distributor-text-center" style={{
                padding: '16px 12px',
                textAlign: 'center',
                fontSize: '13px',
                fontWeight: '600',
                color: '#666',
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                borderBottom: '2px solid #e0e0e0'
              }}>
                Industry
              </th>
              <th className="distributor-th distributor-text-center" style={{
                padding: '16px 12px',
                textAlign: 'center',
                fontSize: '13px',
                fontWeight: '600',
                color: '#666',
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                borderBottom: '2px solid #e0e0e0'
              }}>Tag</th>
              <th className="distributor-th distributor-text-center" style={{
                padding: '16px 12px',
                textAlign: 'center',
                fontSize: '13px',
                fontWeight: '600',
                color: '#666',
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                borderBottom: '2px solid #e0e0e0'
              }}>Views</th>
              {/* <th className="distributor-th distributor-text-center" style={{
                padding: '16px 12px',
                textAlign: 'center',
                fontSize: '13px',
                fontWeight: '600',
                color: '#666',
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                borderBottom: '2px solid #e0e0e0'
              }}>Share</th> */}
              {/* <th className="distributor-th distributor-text-center" style={{
                padding: '16px 12px',
                textAlign: 'center',
                fontSize: '13px',
                fontWeight: '600',
                color: '#666',
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                borderBottom: '2px solid #e0e0e0'
              }}>
                Downloads
              </th> */}
              <th className="distributor-th distributor-text-center" style={{
                padding: '16px 12px',
                textAlign: 'center',
                fontSize: '13px',
                fontWeight: '600',
                color: '#666',
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                borderBottom: '2px solid #e0e0e0'
              }}>
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {upmedia.length === 0 ? (
              <tr>
                <td colSpan="8" style={{
                  padding: '40px',
                  textAlign: 'center',
                  fontSize: '14px',
                  color: '#999',
                  fontWeight: '400'
                }}>
                  No media files found
                </td>
              </tr>
            ) : (
              upmedia.map((uploads, index) => {
              const globalIndex = ((paginationInfo?.currentPage || 1) - 1) * (paginationInfo?.limit || 10) + index;
              return (
              <tr key={uploads.id} style={{
                borderBottom: '1px solid #f0f0f0',
                transition: 'background-color 0.2s ease',
                background: globalIndex % 2 === 0 ? '#fff' : '#fafafa'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#f8f9fa';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = globalIndex % 2 === 0 ? '#fff' : '#fafafa';
              }}>
                <td className="distributor-td distributor-text-center" style={{
                  padding: '14px 12px',
                  textAlign: 'center',
                  fontSize: '14px',
                  fontWeight: '400',
                  color: '#333'
                }}>
                  {uploads.title}
                </td>
                <td className="distributor-td distributor-text-center" style={{
                  padding: '14px 12px',
                  textAlign: 'center',
                  fontSize: '14px',
                  fontWeight: '400',
                  color: '#555'
                }}>
                  <span style={{
                    background: '#e3f2fd',
                    color: '#0A4DA2',
                    padding: '4px 12px',
                    borderRadius: '12px',
                    fontSize: '12px',
                    fontWeight: '500'
                  }}>{uploads.fileType}</span>
                </td>
                <td
                  className="distributor-td distributor-text-center"
                  onClick={(e) => e.stopPropagation()}
                  style={{
                    padding: '14px 12px',
                    textAlign: 'center',
                    fontSize: '14px',
                    fontWeight: '400',
                    color: '#555'
                  }}
                >
                  {uploads.industry}
                </td>
                <td
                  className="distributor-td distributor-text-center"
                  onClick={(e) => e.stopPropagation()}
                  style={{
                    padding: '14px 12px',
                    textAlign: 'center',
                    fontSize: '14px',
                    fontWeight: '400',
                    color: '#555'
                  }}
                >
                  {uploads.tag}
                </td>
                <td
                  className="distributor-td distributor-text-center"
                  onClick={(e) => e.stopPropagation()}
                  style={{
                    padding: '14px 12px',
                    textAlign: 'center',
                    fontSize: '14px',
                    fontWeight: '400',
                    color: '#666'
                  }}
                >
                  <span style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '4px'
                  }}>
                    {uploads.views}
                  </span>
                </td>
                {/* <td
                  className="distributor-td distributor-text-center"
                  onClick={(e) => e.stopPropagation()}
                  style={{
                    padding: '14px 12px',
                    textAlign: 'center',
                    fontSize: '14px',
                    fontWeight: '400',
                    color: '#666'
                  }}
                >
                  {uploads.share}
                </td> */}
                {/* <td
                  className="distributor-td distributor-text-center"
                  onClick={(e) => e.stopPropagation()}
                  style={{
                    padding: '14px 12px',
                    textAlign: 'center',
                    fontSize: '14px',
                    fontWeight: '400',
                    color: '#666'
                  }}
                >
                  {uploads.downloads}
                </td> */}

                <td
                  className="distributor-td distributor-text-center"
                  onClick={(e) => e.stopPropagation()}
                  style={{
                    padding: '14px 12px',
                    textAlign: 'center'
                  }}
                >
                  <div className="distributor-action-container" style={{
                    position: 'relative',
                    display: 'inline-block'
                  }}>
                    <HiDotsVertical
                      className="distributor-action-icon"
                      color="#666"
                      size={20}
                      onClick={(e) => handleActionClick(e, uploads.id)}
                      style={{
                        cursor: 'pointer',
                        padding: '4px',
                        borderRadius: '4px',
                        transition: 'background 0.2s ease'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background = '#f0f0f0';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = 'transparent';
                      }}
                    />
                    {activeDropdown === uploads.id && (
                      <div
                        className="category-dropdown-menu distributor-action-dropdown-menu"
                        style={{
                          ...menuPosition,
                          background: '#fff',
                          borderRadius: '8px',
                          boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                          border: '1px solid #e8e8e8',
                          overflow: 'hidden',
                          minWidth: '140px'
                        }}
                      >
                        <div
                          className="category-dropdown-item distributor-dropdown-item"
                          onClick={(e) => {
                            e.stopPropagation();
                            navigate(`/mediauploads/${uploads.id}`, {
                              state: { uploads },
                            });
                          }}
                          style={{
                            padding: '10px 14px',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            fontSize: '14px',
                            fontWeight: '400',
                            color: '#555',
                            transition: 'background 0.15s ease'
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background = '#f5f5f5';
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = 'transparent';
                          }}
                        >
                          <IoEye className="icons" size={16} /> View
                        </div>
                        <div
                          className="category-dropdown-item distributor-dropdown-item"
                          onClick={(e) => {
                            e.stopPropagation();
                            navigate(`/mediauploads/EditMultimedia/${uploads.id}`, {
                              state: { uploads },
                            });
                          }}
                          style={{
                            padding: '10px 14px',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            fontSize: '14px',
                            fontWeight: '400',
                            color: '#555',
                            transition: 'background 0.15s ease'
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background = '#f5f5f5';
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = 'transparent';
                          }}
                        >
                          <MdOutlineModeEdit className="icons" size={16} /> Edit
                        </div>
                        <div
                          className="category-dropdown-item distributor-dropdown-item distributor-dropdown-item-delete"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleDelete(uploads.id);
                          }}
                          style={{
                            padding: '10px 14px',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            fontSize: '14px',
                            fontWeight: '400',
                            color: '#e74c3c',
                            transition: 'background 0.15s ease',
                            borderTop: '1px solid #f0f0f0'
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background = '#fef5f5';
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = 'transparent';
                          }}
                        >
                          <MdDeleteOutline className="icons" size={16} /> Delete
                        </div>
                      </div>
                    )}
                  </div>
                </td>
              </tr>
            );
            })
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination Section */}
      {paginationInfo && (
      <div
        style={{ 
          marginTop: "20px", 
          display: "flex", 
          flexDirection: "column",
          alignItems: "center",
          gap: "16px"
        }}
      >
        <div style={{
          fontSize: '14px',
          color: '#666',
          fontWeight: '400'
        }}>
          Showing {((paginationInfo.currentPage - 1) * paginationInfo.limit) + 1} to {Math.min(paginationInfo.currentPage * paginationInfo.limit, paginationInfo.totalDocs)} of {paginationInfo.totalDocs} entries
        </div>
        <Pagination
          currentPage={paginationInfo.currentPage}
          totalPages={paginationInfo.totalPages}
          onPageChange={handlePageChange}
        />
      </div>
      )}
    </>
  );
};

export default Multimedias;
